module.exports = __webpack_public_path__ + "static/media/icn.db897f35.svg";